import React from "react";
import { useSearchParams } from "react-router";
import { FILE_BROWSER_ROUTES } from "../../constants";
import { generateFileBrowserLink } from "../utils";
import { LinkToReportTab } from "./index";
const ComponentPriorityAndIssuesLink = ({ htmlId, componentId, componentPath, target, children, }) => {
    const [searchParams] = useSearchParams();
    if (target === "classification") {
        return (React.createElement(LinkToReportTab, { id: `info-link-${htmlId}`, underline: "none", to: generateFileBrowserLink({
                searchParams,
                componentId,
                componentPath,
                fileBrowserPage: FILE_BROWSER_ROUTES.INFO_ROUTE,
            }) }, children));
    }
    else if (target === "issues") {
        return (React.createElement(LinkToReportTab, { id: `issues-link-${htmlId}`, underline: "none", to: generateFileBrowserLink({
                searchParams,
                componentId,
                componentPath,
                fileBrowserPage: FILE_BROWSER_ROUTES.ISSUES_ROUTE,
            }) }, children));
    }
    else {
        return (React.createElement(LinkToReportTab, { id: `vulnerabilities-link-${htmlId}`, underline: target === "cve" ? "none" : "always", to: generateFileBrowserLink({
                searchParams,
                componentId,
                componentPath,
                fileBrowserPage: FILE_BROWSER_ROUTES.VULNERABILITIES_ROUTE,
            }) }, children));
    }
};
export default ComponentPriorityAndIssuesLink;
//# sourceMappingURL=ComponentPriorityAndIssuesLink.js.map